module.exports = __webpack_public_path__ + "img/5.b20e8d92.png";